define('modules/lists/lists.module',["client"],
function(Prospector){
    Prospector.module("ListApp", function(ListApp, Prospector, Backbone, Marionette, $, _){
        ListApp.startWithParent = false;

        ListApp.onStart = function(){
            window.utils.rawOutput("starting ListApp");
        };

        ListApp.onStop = function(){
            window.utils.rawOutput("stopping ListApp");
        };
    });

    Prospector.module("Routers.ListApp", function(ListAppRouter, Prospector, Backbone, Marionette, $, _){
        ListAppRouter.Router = Marionette.AppRouter.extend({
            appRoutes: {
                //"list/:sourceId/:refId"    : "list"
            }
        });

        var API = {
            // list: function(sourceId, refId) {
            //     var func = $.proxy(function () {
            //         require(["modules/lists/main/list.controller"], function (ListController) {
            //             window.utils.raygunTrack('list');
            //             ListController.loadList(sourceId, refId);
            //         });
            //     }, this);
            //     Prospector.trigger("authAcc", func);
            // },
            showEditContactModal: function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showEditContact(criterion);
                });
            },
            showEditContactsModal: function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showEditContacts(criterion);
                });
            },
            showDeleteListModal: function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showDeleteList(criterion);
                });
            },
            showDeleteContactModal: function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showDeleteContactModal(criterion);
                });
            },
            showCreatePerson:function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showCreatePerson(criterion);
                });
            },
            showCreateCompany:function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showCreateCompany(criterion);
                });
            },
            showListQuota:function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showListQuota(criterion);
                });
            },
            showListQuota2:function(criterion){
                require(["modules/lists/modals/modals.controller"], function(ListController) {
                    ListController.showListQuota2(criterion);
                });
            },
        };

        Prospector.on("createPerson", function(options){
            API.showCreatePerson(options);
        });

        Prospector.on("createCompany", function(options){
            API.showCreateCompany(options);
        });

        Prospector.on("showEditContactsModal", function(options){
            API.showEditContactsModal(options);
        });

        Prospector.on("showEditContactModal", function(options){
            API.showEditContactModal(options);
        });

        Prospector.on("showDeleteListModal", function(options) {
            API.showDeleteListModal(options);
        });

        Prospector.on("showDeleteContactModal", function(options) {
            API.showDeleteContactModal(options);
        });

        Prospector.on("showListQuota", function(options) {
            API.showListQuota(options);
        });

        Prospector.on("showListQuota2", function(options) {
            API.showListQuota2(options);
        });

        Prospector.addInitializer(function(){
            //Prospector.trigger("loadCss", "assets/css/list.css");
            new ListAppRouter.Router({
                controller: API
            });
        });
    });
    return Prospector.ListAppRouter;
});
